import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor() {}

  success(msg: string) {
    const Toaster = Swal.mixin({
      toast: true,
      position: 'bottom-left',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });
    Toaster.fire({
      icon: 'success',
      title: msg,
    });
  }

  warning(msg: string) {
    const Toaster = Swal.mixin({
      toast: true,
      position: 'bottom-left',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });
    Toaster.fire({
      icon: 'warning',
      title: msg,
    });
  }

  error(msg: string) {
    const Toaster = Swal.mixin({
      toast: true,
      position: 'bottom-left',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });
    Toaster.fire({
      icon: 'error',
      title: msg,
    });
  }

  customeErrorMessage(text: string) {
    const Toaster = Swal.mixin({
      toast: true,
      position: 'bottom-left',
      showConfirmButton: false,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });
    Toaster.fire({
      icon: 'warning',
      title: text,
    });
  }

  /**
   * Show notification toast in top-right position
   * Used for real-time notifications from SignalR
   */
  notificationToast(title: string, message?: string, icon: 'success' | 'info' | 'warning' | 'error' = 'info') {
    const Toaster = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });
    Toaster.fire({
      icon: icon,
      title: title,
      text: message,
    });
  }
}
